import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
   setTimerRunning,
   setTimerShowPopup,
   setTimerTime,
   setSolutionIncubated
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].type,
    showPopup: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].showPopup,
    running: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].running,
    time: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].time,
    interactionProps: {
      heatBlocks: state.notebook.protocolSection.scene.apparatus.heatBlocks
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
   setRunning: (data) => {
      dispatch(setTimerRunning(data))
   },
   setShowPopup: (data) => {
      dispatch(setTimerShowPopup(data))
   },
   setTime: (data) => {
      dispatch(setTimerTime(data))
   },
   setSolutionIncubated: (data) => {
    dispatch(setSolutionIncubated(data))
   },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
